<div class="title">Attributes<button *ngIf="selectedType !== ''" type="button"
  class="rounded btn btn-sm btn-primary"
    (click)="Add()">
    <span class="fas fa-plus"></span>
  </button></div>
<div class="workspace">
  <div class="form-group">
    <label>Define attributes for:</label>
    <select (change)="HandleTypeChange()" [(ngModel)]="selectedType" class="form-control">
      <option value="point">Points</option>
      <option value="segment">Segments</option>
      <option value="supplemental">Supplemental</option>
    </select>
  </div>
  <div class="">
    <div #pointAtts class="listing list-points container stateful req-atts-point" >
      <div [attr.data-att-id]="pointAttribute.id" (focus)="SelectPointAttribute(pointAttribute  )" tabindex="0" class="attribute" dragula="point-attributes" *ngFor="let pointAttribute of pointAttributes" (click)="SelectPointAttribute(pointAttribute)">
        <span class="handle fas fa-grip-horizontal"></span>
        <span title="{{pointAttribute.label}}" class="att-label">{{pointAttribute.label}}</span>
        <button (click)="Delete(pointAttribute)" type="button" class="rounded btn btn-sm btn-danger"><span class="fas fa-times"></span></button></div>
    </div>
    <div #segmentAtts class="listing list-segments container stateful req-atts-segment" >
      <div (focus)="SelectSegmentAttribute(segmentAttribute)" tabindex="0" class="attribute"  *ngFor="let segmentAttribute of segmentAttributes" (click)="SelectSegmentAttribute(segmentAttribute)">
        <span class="handle fas fa-grip-horizontal"></span>
        <span class="att-label">{{segmentAttribute.label}}</span>
        <button (click)="Delete(segmentAttribute)" type="button" class="rounded btn btn-sm btn-danger"><span class="fas fa-times"></span></button></div>
    </div>
    <div #supplAtts class="listing list-supplemental container stateful req-atts-suppl" >
      <div (focus)="SelectSupplementalAttribute(supplementalAttribute)" tabindex="0" class="attribute"  *ngFor="let supplementalAttribute of supplementalAttributes"
        (click)="SelectSupplementalAttribute(supplementalAttribute)">
        <span class="handle fas fa-grip-horizontal"></span>
        <span class="att-label">{{supplementalAttribute.label}}</span
        ><button (click)="Delete(supplementalAttribute)" type="button" class="rounded btn btn-sm btn-danger"><span class="fas fa-times"></span></button></div>
    </div>
  </div>
</div>
